import { type User as CoreUser } from '@grammarly/http-clients-auth-v5'

const noneUserData = {} as CoreUser

export class User {
  public static None: User = new User(noneUserData)

  public static create(data?: CoreUser | null): User {
    return data ? new User(data) : User.None
  }

  constructor(private data: CoreUser) {}

  private getAttr<T extends keyof CoreUser>(attr: T): CoreUser[T] {
    return this.data[attr]
  }

  get id() {
    return this.getAttr('id')
  }

  get isNone() {
    return this === User.None
  }

  get isAnonymous() {
    const isAnon = this.getAttr('anonymous')
    return typeof isAnon === 'boolean' ? isAnon : this.isNone ? true : false
  }

  get isTest() {
    return this.getAttr('isTest')
  }

  get email() {
    return this.getAttr('email')
  }
}
